import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { BlockTypeDropdown } from '../../components/BlockTypeDropdown'
import { BoldButton } from '../../components/BoldButton'
import { BulletListButton } from '../../components/BulletListButton'
import { ClearFormatButton } from '../../components/ClearFormatButton'
import { FontBackgroundColorButton } from '../../components/FontBackgroundColorButton'
import { FontColorButton } from '../../components/FontColorButton'
import { FontSizeDropdown } from '../../components/FontSizeDropdown'
import { FormatPainterButton } from '../../components/FormatPainterButton'
import { InsertDropdown } from '../../components/InsertDropdown'
import { ItalicButton } from '../../components/ItalicButton'
import { LineHeightDropdown } from '../../components/LineHeightDropdown'
import { NumberedListButton } from '../../components/NumberedListButton'
import { RedoButton } from '../../components/RedoButton'
import { StrikethroughButton } from '../../components/StrikethroughButton'
import { SuperSubDropdown } from '../../components/SuperSubDropdown'
import { TableCellBackgroundColorButton } from '../../components/TableCellBackgroundColorButton'
import { TableVerticalAlignDropdown } from '../../components/TableVerticalAlignDropdown'
import { TextAlignDropdown } from '../../components/TextAlignDropdown'
import { UnderlineButton } from '../../components/UnderlineButton'
import { UndoButton } from '../../components/UndoButton'

import { ToolbarStoreContext } from './contexts/StoreContext'
import { createToolbarStore } from './store/createStore'

const rawGroups = [
  [
    <UndoButton key='undo' />,
    <RedoButton key='redo' />,
    <FormatPainterButton key='formatPainter' />,
    <ClearFormatButton key='clearFormat' />
  ],
  [<BlockTypeDropdown key='blockFormat' />],
  [
    <FontSizeDropdown key='fontSize' />,
    <BoldButton key='bold' />,
    <ItalicButton key='italic' />,
    <UnderlineButton key='underline' />,
    <StrikethroughButton key='strikethrough' />,
    <SuperSubDropdown key='superSub' />,
    <FontColorButton key='fontColor' />,
    <FontBackgroundColorButton key='fontBackgroundColorButton' />,
    <TableCellBackgroundColorButton key='tableCellBackgroundColor' />
  ],
  [
    <TextAlignDropdown key='align' />,
    <TableVerticalAlignDropdown key='tableVerticalAlign' />,
    <LineHeightDropdown key='lineHeight' />,
    <BulletListButton key='bulletList' />,
    <NumberedListButton key='numberedList' />
  ]
]

const permanentGroup = [<InsertDropdown key='insert' />]

export const ToolbarStoreProvider = ({ children }: PropsWithChildren) => {
  const store = useCreation(() => {
    return createToolbarStore({ rawGroups, permanentGroup })
  }, [rawGroups, permanentGroup])

  return <ToolbarStoreContext value={store}>{children}</ToolbarStoreContext>
}
